<template>
  <div :key="forceRefreshKey">
    <component
      v-if="component.params.pure"
      v-bind="componentProps"
      :is="dynamicComponent"
      :class="styleOptions"
      :params="params"
      :formName="component.params.base.entity"
      :dictionary="component.params.dictionary"
    />
    <Panel
      v-else
      v-bind="component.panel"
      :class="styleOptions"
      :collapse="!!component.panel.collapse"
      :helpy="component.params.helpy"
      :data-type="component.type"
      :footer="component.panel.footer"
    >
      <component
        :is="dynamicComponent"
        v-bind="componentProps"
        :extra-options="component.params.base.extraOptions"
        :controller-name="controllerName"
        :params="params"
        :formName="component.params.base.entity"
        :dictionary="component.params.dictionary"
      />
      <template v-if="component.params.collapsed.type" slot="collapsed">
        <component
          v-bind="collapsedProps"
          :is="dynamicCollapsed"
          :is-collapsed="true"
          :extra-options="component.params.base.extraOptions"
          :controller-name="controllerName"
        />
      </template>
    </Panel>
  </div>
</template>

<script>
  import { paramsTranslate, dynamicComponentImport } from '../lib/helpers'
  import { get } from 'lodash'
  import Panel from '../../Panel.vue'
  import EventBus from '../../../utils/event-bus'

  /**
   * @class DotoComponent
   *
   * @description This component is a wrapper for different types of Panels
   */

  export default {
    name: 'DotoComponent',
    components: {
      Panel,
    },
    data() {
      return {
        forceRefreshKey: 0,
      }
    },
    props: {
      url: {
        type: String,
        required: true,
      },
      params: {
        type: Object,
        default: () => ({}),
      },
      component: {
        type: Object,
        required: true,
      },
      uid: {
        type: String,
        required: true,
      },
      isInDashboard: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      styleOptions() {
        return get(this.component, 'params.base.list.styleOptions.className')
      },
      controllerName() {
        return this.component.params.base.controllerName !== '' ? this.component.params.base.controllerName : undefined
      },
      collapseStoreId() {
        return `panelCollapse-${this.uid}-${this.component.position.i}`
      },
      fixedHeight() {
        return get(this.component, 'panel.fixHeight', false)
      },
      dynamicComponent() {
        return dynamicComponentImport(this.component.type)
      },
      dynamicCollapsed() {
        return dynamicComponentImport(this.component.params.collapsed.type)
      },
      computedProps() {
        const props = {
          isInDashboard: this.isInDashboard,
          collapseStoreId: this.collapseStoreId,
          panelUid: this.uid,
          fixHeight: this.fixedHeight,
          componentType: this.component.type,
        }

      const mongoExtraOptions = get(this.component, 'params.base.mongoList.extraOptions')
      if (mongoExtraOptions) {
        props.extraOptions = mongoExtraOptions
      }

      return props
      },
      componentProps() {
        return Object.assign(
          {},
          this.paramsTranslate(
            this.component.params.base,
            this.component.params.dictionary,
            this.url,
            this.component.position.i,
            this.params
          ),
          this.computedProps
        )
      },
      collapsedProps() {
        return Object.assign(
          {},
          this.paramsTranslate(
            this.component.params.collapsed.params.base,
            this.component.params.dictionary,
            this.url,
            this.component.position.i,
            this.params
          ),
          this.computedProps
        )
      },
    },
    methods: {
      paramsTranslate,
    },
    mounted() {
      EventBus.$on('layout-updated', () => {
        if (!this.component.params.keepAlive) this.forceRefreshKey++
      })
    },
  }
</script>
